import { render, staticRenderFns } from "./searchForm.vue?vue&type=template&id=66481537&scoped=true"
import script from "./searchForm.vue?vue&type=script&lang=js"
export * from "./searchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66481537",
  null
  
)

export default component.exports